import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Image, Typography } from "antd";
import { FundTwoTone } from "@ant-design/icons";
import { breakpoints } from "theme/media";
import { Menu, Sider } from "./elements";
import { useUser } from "providers/user";
import Logo from "./veikulWhite.png";

const { Item } = Menu;
const { Text } = Typography;
const Sidebar = ({ history, collapsed, onCollapse }) => {
  const { user } = useUser();

  const [isLg, toggleLg] = useState(window.innerWidth > breakpoints.lg);

  const updateWidth = () => {
    toggleLg(window.innerWidth > breakpoints.lg);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);
  let routes = (
    <>
      <Item icon={<FundTwoTone twoToneColor={"twoToneColor"} />} key="/leads">
        <Link to="/leads">
          <Text strong style={{ color: "white" }}>
            Leads
          </Text>
        </Link>
      </Item>

      {!user?.support?.partner && (
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/followup"
        >
          <Link to="/followup">
            <Text strong style={{ color: "white" }}>
              Seguimiento
            </Text>
          </Link>
        </Item>
      )}

      {!user?.support?.partner && (
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/configurations"
        >
          <Link to="/configurations">
            <Text strong style={{ color: "white" }}>
              Configuraciones
            </Text>
          </Link>
        </Item>
      )}

      <Item icon={<FundTwoTone twoToneColor={"twoToneColor"} />} key="/funnel">
        <Link to="/funnel">
          <Text strong style={{ color: "white" }}>
            Rendimiento
          </Text>
        </Link>
      </Item>

      {!user?.support?.partner && (
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/visits"
        >
          <Link to="/visits">
            <Text strong style={{ color: "white" }}>
              Citas
            </Text>
          </Link>
        </Item>
      )}
    </>
  );
  return (
    <Sider
      theme="dark"
      breakpoint="lg"
      collapsedWidth={isLg ? "80" : "0"}
      collapsed={collapsed}
      collapsible
      style={{
        background: "radial-gradient(ellipse at top, #000000, #142b22)",
      }}
      onCollapse={onCollapse}
    >
      <Image
        style={{
          margin: "15px auto",
          display: "block",
          paddingLeft: 40,
          paddingRight: 40,
        }}
        preview={false}
        height={25}
        src={Logo}
        alt=""
      />
      <Menu
        theme="dark"
        style={{
          marginTop: 20,
          background: "transparent",
          paddingg: 10,
        }}
        defaultSelectedKeys={history.location.pathname.toLowerCase()}
        selectedKeys={history.location.pathname.toLowerCase()}
        mode="inline"
      >
        {routes}
      </Menu>
    </Sider>
  );
};

export default withRouter(Sidebar);
